import { ReactComponent as CloseIcon } from 'core/assets/images/icones/closeIcon.svg'
import { DarkThemeContext } from 'core/contexts/DarkThemeContext'
import React, { FC, useContext } from 'react'
import { Modal as ModalComponent, ModalProps } from 'react-responsive-modal'
import 'react-responsive-modal/styles.css'

const ModalWrapper: FC<React.PropsWithChildren<ModalProps>> = (props) => {
  const { children, classNames: propsClassName } = props
  const { isDarkTheme } = useContext(DarkThemeContext)

  return (
    <ModalComponent
      {...props}
      classNames={{
        ...props.classNames,
        modal:
          `${propsClassName?.modal ?? ''} ${isDarkTheme ? 'dark' : ''}`.trim(),
      }}
      modalId="modal"
      center={props.center ?? true}
    >
      <div
        className="absolute top-[20px] right-[30px] cursor-pointer md:hidden block dark:text-gray-1325"
        onClick={props.onClose}
      >
        <CloseIcon />
      </div>
      {children}
    </ModalComponent>
  )
}
export default ModalWrapper
